/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.CONNECTION_WEBHOOKS_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.connectionWebhooks,
                (memo, connectionWebhook) => {
                    const { connection_id } = connectionWebhook;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[connection_id] = connectionWebhook;
                    return memo;
                },
                state,
            );
        }
    },
);